export default "__VITE_ASSET__BlVrd1gt__"